import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-index',
  templateUrl: './login-index.component.html',
  styleUrls: ['./login-index.component.css']
})
export class LoginIndexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
